import request from '@/api/clients/portal-client'

// 获取充值套餐列表
export function getRechargePackageList() {
  return request({
    url: '/mall/rechargePackage/list',
    method: 'get'
  })
}
